<template>
  <div :class="['card-service-container', {'is-active' : isFocus }]"
       :style="{
          'z-index': 8 - item.id
       }"
       @click="changeId"
       @mouseleave="focusFalse"
       @mouseenter="focusTrue"
  >
    <div class="card-service-content">
      <div :class="['num-title-container',
      'medium-title',
      `${!isFocus ? 'orange' : 'white'}-title`]">
        {{ numTitle }}
      </div>
      <div class="bottom-container">
        <sub-title
            class="sub-title-container"
            :color="!isFocus ? 'dark-purple' : 'white'">
          {{ item.title }}
        </sub-title>
        <div :class="['card-service-title-container']" :style="{height: activeHeight}">
          <main-paragraph
              :class="[className]"
              :font-family="'Verdana'">
            {{ item.text }}
          </main-paragraph>
        </div>
      </div>
    </div>
    <transition name="fade-opacity-lazy">
      <div class="box-shadow" v-if="isFocus"></div>
    </transition>
<!--    <div :class="['bg-container', getDirectionDecoration()]">-->
<!--      <img v-if="!isFocus" :src="getUrl('service-new.svg')" alt="decoration">-->
<!--    </div>-->
  </div>
</template>

<script>
import MiniTitle from "@/components/shared/text/MiniTitle.vue";
import MainParagraph from "@/components/shared/text/MainParagraph.vue";
import SubTitle from "@/components/shared/text/SubTitle.vue";

export default {
  name: "CardService",
  components: {SubTitle, MainParagraph, MiniTitle},
  props: {
    focusParamId: {
      type: [Number,Boolean],
      required: true
    },
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      activeHeight: 0
    }
  },
  computed: {
    className() {
      return `card-service-title-container-${this.item.id}`
    },
    isFocus() {
      return this.focusParamId === this.item.id;
    },
    numTitle() {
      return `0${ this.item.id + 1 }.`
    }
  },
  mounted() {
    if(this.$isMobile && this.isFocus) {
      this.changeId();
    }
  },
  watch: {
    focusParamId() {
     if(!this.isFocus) {
       this.activeHeight = 0;
     } else {
       this.changeId();
     }
    }
  },
  methods: {
    focusTrue() {
      if(!this.$isMobile) {
        this.changeId()
      }
    },
    changeId() {
      let block = document.querySelector(`.${this.className}`);
      this.$nextTick(() => {
        this.activeHeight = `${block.clientHeight}px`;
      })
      if(!this.$isMobile) {
        this.$emit('changeId', this.item.id);
      }
    },
    focusFalse() {
      if(!this.$isMobile) {
        this.activeHeight = 0;
        this.$emit('changeId', false)
      }
    },
    getDirectionDecoration() {
      if(this.item.id > 4) {
        return 'bottom'
      } else {
        return 'top'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card-service-container {
  position: relative;
  overflow: hidden;
  box-shadow: 0 0 50px var(--color-pink);

  .box-shadow {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    position: absolute;
    box-shadow: 0 0 50px var(--color-dark-pink);
  }
  &.is-active {
    box-shadow: none;
    .card-service-content {
      background-color: var(--color-orange);
      .bottom-container {
        .card-service-title-container
 {
          opacity: 1;
        }
      }
    }
  }
  .card-service-content {
    transition: all .6s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    @media(max-width: 769px) {
      background: #FFFFFF;
    }
    .bottom-container {
      display: flex;
      flex-direction: column;
      .sub-title-container {
        line-height: 120%;
        transition: all .6s ease;
      }
      .card-service-title-container {
        overflow: hidden;
        height: 0;
        opacity: 0;
        transition: all .6s ease;

        .text-content {
          line-height: 140%;
        }
      }
    }
  }
}
  @media (max-width: 3024px){
    .card-service-container {
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 4px;
            }
          }
        }
      }
      .num-title-container {
        font-size: 28px;
      }
      .card-service-content {
        padding: 40px;
      }
    }

  }


  @media (max-width: 1920px) {
    .card-service-container {
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 4px;
            }
          }
        }
      }
      .num-title-container {
        font-size: 24px;
      }
      .card-service-content {
        padding: 40px;
      }
    }
  }
  @media (max-width: 1600px) {
    .card-service-container {
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 4px;
            }
          }
        }
      }
      .num-title-container {
        font-size: 20px;
      }
      .card-service-content {
        padding: 20px;
      }
    }
  }
  @media (max-height: 800px) {
    .card-service-container {
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 4px;
            }
          }
        }
      }
      .num-title-container {
        font-size: 18px;
      }
    }
  }

  @media (max-width: 1400px) and (min-height: 801px) {

    .card-service-container {
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 4px;
            }
          }
        }
      }
      .num-title-container {
        font-size: 20px;
      }
    }
  }

  @media (max-width: 1133px) {
    .card-service-container {
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 4px;
            }
          }
        }
      }
      .num-title-container {
        font-size: 18px;
      }
    }
  }
  @media (max-width: 769px) {
    .card-service-container {
      height: 100%;
      box-shadow: none;
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 4px;
            }
          }
        }
      }
      .card-service-content {
        padding: 20px;
      }
    }
    //iPhone 14
  }

  @media (max-width: 769px)  and (min-height: 720px) and (max-height: 1000px) {
    //iPhone Plus
  }
  @media (min-height: 600px) and (max-height: 630px){
    //для экранов 8 плюс
  }

  @media (max-width: 375px){
    //iPhone 8
  }


  @media (max-width: 375px) and (min-height: 630px) {
    //iPhone X
  }


  @media (max-width: 320px) {
    //iPhone SE
  }

  @media (min-width: 3025px) {

    .card-service-container {
      &.is-active {
        .card-service-content {
          .bottom-container {
            .sub-title-container {
              margin-bottom: 12px;
            }
          }
        }
      }
      .num-title-container {
        font-size: 52px;
      }
      .card-service-content {
        padding: 60px;
      }
    }
  }

</style>